import { queryOptions } from '@tanstack/react-query'
import { exportTemplatesApi } from './api'
import { ExportTemplateFilter } from './models'
import { Pagination } from '@thinknimble/tn-models'

export const exportTemplateQueries = {
  all: () => ['export-templates'],

  retrieve: (id: string) =>
    queryOptions({
      queryKey: [...exportTemplateQueries.all(), id],
      queryFn: () => exportTemplatesApi.retrieve(id),
      enabled: Boolean(id),
    }),

  list: ({
    filters,
    pagination,
  }: {
    filters?: Partial<ExportTemplateFilter>
    pagination?: Pagination
  }) =>
    queryOptions({
      queryKey: [...exportTemplateQueries.all(), { filters, pagination }],
      queryFn: () => exportTemplatesApi.list({ filters, pagination }),
      enabled: true,
    }),
}
